import { render, staticRenderFns } from "./PlatformSettings.vue?vue&type=template&id=feb22342&"
import script from "./PlatformSettings.vue?vue&type=script&lang=js&"
export * from "./PlatformSettings.vue?vue&type=script&lang=js&"
import style0 from "./PlatformSettings.vue?vue&type=style&index=0&lang=less&scoped%5D=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports